import StandingsBase from "./StandingsBase";

export default function StandingsMarken() {
    return (
        <StandingsBase
            scopeType="BRAND"
            classKey=""
            heading="Meisterschaftswertung"
            pillLabel="MARKE"
        />
    );
}
